/**
 * BE Redis NX 락이 같은 key 로 네트워크 레이어 중복(자동 재시도 등)을 차단하도록
 * mutation 호출 시점에 1회 생성하는 멱등성 키.
 *
 * BE Pattern `^[A-Za-z0-9_-]{1,128}$` 와 호환:
 * - `crypto.randomUUID()` (지원 환경): 36자 hex+`-`
 * - fallback: `${Date.now()}-${Math.random().toString(36).slice(2)}` 영숫자 only
 */
export const generateIdempotencyKey = (): string => {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
};
